var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.458 25.9384L27.648 22.1452C32.4631 24.9252 34.7828 28.2275 35.3203 32.8564C37.0204 27.6718 36.9957 21.5146 30.798 16.6893L32.928 13L22.2698 15.4605L25.458 25.9384Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1088",
    x: 6,
    y: 36,
    width: 36,
    height: 5,
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 595"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1089",
    x: 5,
    y: 33.1768,
    width: 36,
    height: 3,
    transform: "rotate(-60 5 33.1768)",
    fill: "#003E6B"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1093",
    x: 8,
    y: 32,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#003E6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenObject);
export default __webpack_public_path__ + "static/media/open_object.646427486a423e17b6ea8811a3cc0dfc.svg";
export { ForwardRef as ReactComponent };